import React, { useState } from "react";
import { Box, Divider, Stack } from "@mui/material";
import "./TopAppBar.scss";
import { useGenerateTransportKey } from "../../services/user/service";
import RegisterModal from "./RegisterModal";

const TopAppBar: React.FC = () => {
  const { getTransportKey } = useGenerateTransportKey();

  const storedData = localStorage.getItem("userInfo");
  const userInfo = storedData ? JSON.parse(storedData) : {};
  const status = userInfo.statuses;
  const [navigateValue, setNavigateValue] = useState("");
  const [filteredStatus, setFilteredStatus] = useState(status);

  const navigateToAftermarket = () => {
    if(status.filter((statuses: any) => statuses.applicationId == "OKC" && statuses.status == "Active").length > 0)
    {
      const payload = {
        applicationId: "OKC",
        uri: `${process.env.REACT_APP_AFTERMARKET_URL}web-transport-landing`,
        isPBE: false,
      };
      getTransportKey(payload);
    }
    else{
      setFilteredStatus(status.filter((statuses: any) => statuses.applicationId == "OKC"));
      setNavigateValue("Aftermarket");
    }
  };

  const navigateToSalvage = () => {
    if(status.filter((statuses: any) => statuses.applicationId == "SAL" && statuses.status == "Active").length > 0)
    {
      const payload = {
        applicationId: "SAL",
        uri: `${process.env.REACT_APP_SALVAGE_URL}web-transport-landing`,
        isPBE: false,
      };
      getTransportKey(payload);
    }
    else{
        setFilteredStatus(status.filter((statuses: any) => statuses.applicationId == "SAL"));
        setNavigateValue("Salvage");
    }
  };

  const navigateToFinishMaster = () => {
    if(status.filter((statuses: any) => statuses.applicationId == "OKC" && statuses.status == "Active").length > 0)
    {
      const payload = {
        applicationId: "OKC",
        uri: `${process.env.REACT_APP_AFTERMARKET_URL}web-transport-landing`,
        isPBE: true,
      };
      getTransportKey(payload);
    }
    else{
        setFilteredStatus(status.filter((statuses: any) => statuses.applicationId == "OKC"));
        setNavigateValue("FinishMaster");
    }
  };

  return (
    <Box className="master-nav-container">
      <Stack
        position="fixed"
        direction="row"
        alignItems="center"
        justifyContent="center"
        className="global-header"
      >
        {/* Portal Logo (opens in new tab) */}
        <Box
          className="logo-section portal"
          onClick={() =>
            window.location.replace(`${process.env.REACT_APP_LKQPORTAL_URL}`)
          }
        />
        <Divider className="divider" orientation="vertical" flexItem />

        {/* Keystone Logo */}
        <Box
          className="logo-section keystone"
          onClick={navigateToAftermarket}
        />
        <Divider className="divider" orientation="vertical" flexItem />
        {/* Salvage Logo */}
        <Box
          className="logo-section salvage"
          // onClick={getSalvageTransportKey}
          onClick={navigateToSalvage}
        />
        <Divider className="divider" orientation="vertical" flexItem />
        {/* Finish Master Logo */}
        <Box
          className="logo-section finish-master"
          // onClick={navigateToFinishMaster}
          onClick={navigateToFinishMaster}
        />
        <Divider className="divider" orientation="vertical" flexItem />
        {/* ADL Logo */}
        <Box className="logo-section adl selected" />
      </Stack>
    <RegisterModal status= {filteredStatus} navigateValue = {navigateValue} />
    </Box>
  );
};

export default TopAppBar;
